import React from 'react';
import {
  render,
  unmountComponentAtNode as remove,
  findDOMNode,
} from 'react-dom';
import Promise from 'promise-polyfill';
import 'whatwg-fetch';
import routes from './router';

import Auth from './components/auth';

// import Buy from './components/buy';
// import Buy from './components/buy-v1';
import Buy from './components/buy-v1.1';

// import { renderBankIframe } from './components/buy-v1/aside/checkout';
import { renderBankIframe } from './components/buy-v1.1/aside/checkout';

import ShowScheme from './components/show-scheme';
import CardActivate from './components/card-activate';
import Profile from './components/profile';
import BonusCardBlock from './components/bonus-card-block';
import Playbill from './components/playbill';
import Popup from './components/popup';
// import BannerAppAd from './components/popup/banner-app-ad';
import BannerAppAd from './components/popup/banner-app-ad';
import { getCookie, setCookie } from './helpers/cookie';

import LandingPopUp from './components/landing-popup/';
import FilmComments from './components/film-comments/';
import FilmNetworkCinemas from './components/film-network-cinemas/';
import SchemeScreen from './components/scheme-screen';
import TownChoices from './components/town-choices';

if (!window.Promise) {
  window.Promise = Promise;
}

const schemeScreenElement = document.getElementById('scheme-screen');

const components = [
  {
    component: <BannerAppAd />,
    target: document.getElementById('banner-app-ad'),
  },
  {
    component: <Auth route={routes.auth} />,
    target: document.getElementById('auth'),
  },
  {
    component: <Profile route={routes.profile} />,
    target: document.getElementById('profile-settings'),
  },
  {
    component: <BonusCardBlock />,
    target: document.getElementById('bonus-card-block'),
  },
  {
    component: <Playbill route={routes.playbill} />,
    target: document.getElementById('playbill'),
  },
  {
    component: <LandingPopUp />,
    target: document.getElementById('landing-town-choose'),
  },
  {
    component: <FilmComments />,
    target: document.getElementById('film-comments'),
  },
  {
    component: <FilmNetworkCinemas />,
    target: document.getElementById('film-network-cinemas'),
  },
  {
    component: <TownChoices townIsOpen={true} position={'static'} />,
    target: document.getElementById('town-choices'),
  },
  {
    component: (
      <SchemeScreen
        route={routes.scheme_screen}
        isAdmin={
          schemeScreenElement &&
          Boolean(schemeScreenElement.dataset.admin || '')
        }
        currentScreen={
          schemeScreenElement && Number(schemeScreenElement.dataset.screen)
        }
      />
    ),
    target: schemeScreenElement,
  },
];

const headers = {
  headers: {
    Accept: 'application/json',
  },
  method: 'GET',
};

if (process.env.NODE_ENV !== 'dev') {
  headers.credentials = 'include';
}

const showPopupAfterAuth = () => {
  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        console.log('DATA,', json.data);
        render(
          <Buy
            session={JSON.parse(localStorage.userChooseInfo).session}
            selected={JSON.parse(localStorage.userChooseInfo).place}
            route={routes.buy}
            routeLogin={routes.auth}
            data={json.data}
          />,
          $('#popup')[0],
        );
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
};

const openBuyPopup = session => {
  if (!session) {
    return;
  }

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(
          <Buy
            selected={[]}
            session={session}
            route={routes.buy}
            routeLogin={routes.auth}
          />,
          $('#popup')[0],
        );
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
};

$(() => {
  components.forEach(item => {
    if (item.target) render(item.component, item.target);
  });

  if (
    getCookie('userChooseInfo') &&
    window.location.pathname ===
      JSON.parse(getCookie('userChooseInfo')).previousPage
  ) {
    showPopupAfterAuth();
  }
});

// Попап покупки билета
// if (process.env.NODE_ENV == 'dev') {
//   setTimeout(function() {
//     $("a[href='#buy']:eq(0)").click();
//   }, 1000);
// }

// $(document).on('click', 'a[href="#buy"]', function(e) {
//   e.preventDefault();

//   const session = $(this).attr('data-session');

//   $.magnificPopup.open({
//     items: {
//       src: '#popup',
//     },

//     closeOnBgClick: false,
//     removalDelay: 250,
//     callbacks: {
//       beforeOpen() {
//         this.st.mainClass = 'mfp-anim';
//       },
//       open() {
//         render(<Buy session={session} route={routes.buy} />, $('#popup')[0]);
//       },
//       close() {
//         render(<div />, $('#popup')[0]);
//       },
//     },
//   });
// });

$(document).on('click', 'a[href="#pay"]', function(e) {
  e.preventDefault();
  // const url = $(this).attr('data-paymentURL');
  const paymentLink = getCookie('PAYMENT_LINK');
  // console.log('PAYMENT_LINK', paymentLink);

  if (window.expire_date - Date.now() > 0) {
    clearTimeout(window.closePopupInterval);
    window.closePopupInterval = setTimeout(() => {
      if ($('#bank_iframe').length > 0) {
        window.postMessage('ticketTimeout', '*');
      }
    }, window.expire_date - Date.now());

    $.magnificPopup.open({
      items: {
        src: '#popup',
      },

      closeOnBgClick: false,
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          window.location.href = paymentLink;
          // renderBankIframe(paymentLink);
        },
        close() {
          render(<div />, $('#popup')[0]);
        },
      },
    });
  } else {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },

      closeOnBgClick: false,
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          render(
            <Popup
              type="alert"
              status="error"
              title="Заказ не оплачен"
              message="Время ожидания оплаты заказа истелко"
              button="Перейти к расписанию сеансов"
              link="/"
            />,
            $('#popup')[0],
          );
        },

        close() {
          render(<div />, $('#popup')[0]);
        },
      },
    });
  }
});

$(document).on('click', 'a[href="#buy"]', function(e) {
  e.preventDefault();

  openBuyPopup($(this).attr('data-session'));
});

$(document).on('click', 'a[href="#my_places"]', function(e) {
  e.preventDefault();

  const session = $(this).attr('data-session');

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim popup--watch';
      },
      open() {
        render(
          <ShowScheme session={session} route={routes.showScheme} />,
          $('#popup')[0],
        );
      },
      close() {
        render(<div />, $('#popup')[0]);
        // remove($('#popup')[0]);
      },
    },
  });
});

// Попап активации карты
$(document).on('click', 'a[href="#card-activate"]', function(e) {
  e.preventDefault();

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<CardActivate route={routes.card} />, $('#popup')[0]);
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

// Попап нашли ошибку
$(document).on('click', 'a[href="#report-popup"]', function(e) {
  e.preventDefault();

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<Popup type="report" />, $('#popup')[0]);
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

$(document).on('click', 'a[href="#banner-app-ad"]', function(e) {
  e.preventDefault();
  const color = $(this).data('color');
  $.magnificPopup.open({
    items: {
      src: '#popup',
      type: 'inline',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    alignTop: false,
    verticalFit: true,

    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<BannerAppAd type={color} />, $('#popup')[0]);
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
});

// Попап вакансия
$(document).on('click', 'a[href="#vacancy-popup"]', function(e) {
  e.preventDefault();

  const vacancy = $(this).attr('data-vacancy');

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<Popup type="vacancy" name={vacancy} />, $('#popup')[0]);
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

const filmText = $('.order__feedback--film').data('film-comment');
const cinemaText = $('.order__feedback--cinema').data('order-comment');

const filmRating = $('.order__feedback--film')
  .find('.emoji-rating')
  .data('rating');

const cinemaRating = $('.order__feedback--cinema')
  .find('.emoji-rating')
  .data('rating');

// const filmRating = '';
// const cinemaRating = '';

// const filmText = '';
// const cinemaText = '';

// Попап редактирования оценки
$(document).on(
  'click',
  '.order__feedback .emoji-rating--active .emoji-rating__item',
  function(e) {
    e.preventDefault();

    const filmId = $(e.target)
      .parents('.order__block')
      .data('film-id');

    const orderId = $(e.target)
      .parents('.order__block')
      .data('order-id');

    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          render(
            <Popup
              type="feedback"
              filmId={filmId}
              orderId={orderId}
              filmRating={filmRating}
              cinemaRating={cinemaRating}
              filmText={filmText}
              cinemaText={cinemaText}
            />,
            $('#popup')[0],
          );
        },
        close() {
          remove($('#popup')[0]);
        },
      },
    });
  },
);

// Попап оценки
$(document).on('click', '.order__commentary', function(e) {
  e.preventDefault();

  const filmId = $(e.target)
    .parents('.order__block')
    .data('film-id');

  const orderId = $(e.target)
    .parents('.order__block')
    .data('order-id');

  // const filmRating = $('.order__feedback--film')
  //   .find('.emoji-rating')
  //   .data('rating');

  // const cinemaRating = $('.order__feedback--cinema')
  //   .find('.emoji-rating')
  //   .data('rating');

  // const filmText = $('.order__feedback--film').data('film-comment');
  // const cinemaText = $('.order__feedback--cinema').data('order-comment');
  // const filmText = '';
  // const cinemaText = '';

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(
          <Popup
            type="feedback-static"
            filmId={filmId}
            orderId={orderId}
            filmRating={filmRating}
            cinemaRating={cinemaRating}
            filmText={filmText}
            cinemaText={cinemaText}
          />,
          $('#popup')[0],
        );
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

// Попап пожаловаться
$(document).on('click', '.complaint__item', function(e) {
  e.preventDefault();

  const filmId = Number(document.querySelector('[data-film]').dataset.film);
  const complaint = $(e.target).data('complaint');
  const commentId = $(e.target)
    .parents('.commentary')
    .data('comment-id');
  const filmText = $(e.target)
    .parents('.commentary')
    .data('comment-text');
  const filmRating = $(e.target)
    .parents('.commentary')
    .data('comment-rate');
  const commentAuthor = $(e.target)
    .parents('.commentary')
    .data('comment-author');

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(
          <Popup
            type={complaint}
            commentId={commentId}
            filmId={filmId}
            filmText={filmText}
            filmRating={filmRating}
            commentAuthor={commentAuthor}
          />,
          $('#popup')[0],
        );
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

// landing-popup
$(document).on('click', 'a[href="#landing-popup"]', function(e) {
  e.preventDefault();

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<LandingPopUp showCloseBtn />, $('#popup')[0]);
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

$(document).on('click', 'a[href="#town-choices"]', function(e) {
  e.preventDefault();

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<TownChoices position={'popup'} />, $('#popup')[0]);
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

// Попап отменить заказ

$(document).on('click', 'a[href="#buy-cancel"]', function(e) {
  e.preventDefault();

  const url = $(this).attr('data-cancel');

  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(
          <Popup
            type="alert"
            status="warning"
            title="Отменить?"
            message="Вы действительно хотите отменить заказ?"
            button="Да, отменить"
            link={url}
          />,
          $('#popup')[0],
        );
      },
      close() {
        remove($('#popup')[0]);
      },
    },
  });
});

// Попап неоплаченного заказа
const unpaidOrder = getCookie('UNPAID_ORDER');
const paymentLink = getCookie('PAYMENT_LINK');

const orderCancelPopup = () => {
  $.magnificPopup.open({
    items: {
      src: '#popup',
    },

    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(
          <Popup
            type="alert"
            status="success"
            title="Заказ отменен"
            message="Теперь вы можете купить другой билет"
            button="Перейти к афише"
            link="/afisha"
          />,
          $('#popup')[0],
        );
      },

      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
};

clearTimeout(window.closePopupInterval);
if (unpaidOrder) {
  fetch(routes.unpaid, headers)
    .then(response => response.json())
    .then(json => {
      if (json.status === 'success' && json.data !== null) {
        // close popup
        // give ten secs to payment expire timeout for network lags
        const extraPaymentTimeout = 10000;
        window.expire_date =
          json.data.expire_date_unix * 1000 - extraPaymentTimeout;
        window.closePopupInterval = setTimeout(() => {
          if ($('#unpaidPopup').length > 0 || $('#bank_iframe').length > 0) {
            window.postMessage('ticketTimeout', '*');
          }
        }, window.expire_date - Date.now());

        if (window.expire_date - Date.now() > 0) {
          $.magnificPopup.open({
            items: {
              src: '#popup',
            },
            closeOnBgClick: false,
            removalDelay: 250,
            callbacks: {
              beforeOpen() {
                this.st.mainClass = 'mfp-anim';
              },
              open() {
                render(
                  <Popup
                    type="unpaid"
                    data={json.data}
                    route={routes.buy.cancel}
                    paymentLink={paymentLink}
                  />,
                  $('#popup')[0],
                );
              },
              close() {
                render(<div />, $('#popup')[0]);
              },
            },
          });
        }
      } else {
        setCookie('UNPAID_ORDER', '');
        setCookie('PAYMENT_LINK', '');
        setCookie('ORDER_ID', '');
        setCookie('SBPPAY', '');
        setCookie('PAYMENT_METHOD', '');
        setCookie('PUSHKIN_FIO', '');
      }
    })
    .catch(() => {});
}

// // Попап успешно
// $(document).on('click', 'a[href="#success-popup"]', function(e) {
// 	e.preventDefault();

// 	$.magnificPopup.open({
// 		items: {
// 			src: '#popup'
// 		},
// 		removalDelay: 250,
// 		callbacks: {
// 			beforeOpen: function() {
// 				this.st.mainClass = 'mfp-anim';
// 			},
// 			open: function() {
// 				render((
// 					<Popup
// 						type="alert"
// 						status="success"
// 						title="Отлично!"
// 						message="Карта успешно активирована. Теперь можете оплачивать заказы бонусами и всякое другое."
// 						button="Понятно"
// 					/>
// 				), $('#popup')[0]);
// 			},
// 			close: function() {
// 				remove($('#popup')[0]);
// 			}
// 		}
// 	});
// });

// Попап не успешно
// $(document).on('click', 'a[href="#error-popup"]', function(e) {
// 	e.preventDefault();

// 	$.magnificPopup.open({
// 		items: {
// 			src: '#popup'
// 		},
// 		removalDelay: 250,
// 		callbacks: {
// 			beforeOpen: function() {
// 				this.st.mainClass = 'mfp-anim';
// 			},
// 			open: function() {
// 				render((
// 					<Popup
// 						type="alert"
// 						status="error"
// 						title="Ошибка!"
// 						message="Так и до тёмной стороны не далеко. Попробуйте еще раз."
// 						button="Назад"
// 					/>
// 				), $('#popup')[0]);
// 			},
// 			close: function() {
// 				remove($('#popup')[0]);
// 			}
// 		}
// 	});
// });
